import type { FirestoreProductSupplyDetail } from "reedy-data/models";
import { routePath } from "~/shared/constants/route-path";

export interface BundleFormat {
  id: string;
  identifier: string;
  title: string;
  author?: string[];
  productGroup: string;
  productGroupDescription: string;
  supplyDetails?: FirestoreProductSupplyDetail[];
}

export const MIN_BUNDLE_FORMATS = 2;

export const productUrl = (productId: string): string =>
  routePath("/books/$productId", { productId });

type IsProductActive = (
  supplyDetails?: FirestoreProductSupplyDetail[],
) => boolean;

// Current ISBN first; active siblings before inactive.
export const orderFormats = (
  formats: BundleFormat[],
  currentIsbn: string,
  isProductActive?: IsProductActive,
): BundleFormat[] => {
  const current = formats.filter((f) => f.identifier === currentIsbn);
  const rest = formats.filter((f) => f.identifier !== currentIsbn);

  if (!isProductActive) {
    return [...current, ...rest];
  }

  const active = rest.filter((f) => isProductActive(f.supplyDetails));
  const inactive = rest.filter((f) => !isProductActive(f.supplyDetails));
  return [...current, ...active, ...inactive];
};
